export default "__VITE_ASSET__bd8c588c__"